import React from 'react';
import { useSelector } from 'react-redux';
import { selectPathname } from 'store/Router/selectors';
import { selectVulnTemplateDetailId } from 'store/KnowledgeBase/selectors';
import {
  Agents,
  KbTitle,
  MCP,
  Scheduler
} from './Titles';

const Title = () => {
  const pathname = useSelector((state) => selectPathname(state));
  const currentVulnTemplate = useSelector(selectVulnTemplateDetailId);
  const showKB = (pathname === '/knowledge_base') ||
  (pathname.includes('/knowledge_base/')) ||
  pathname === `/knowledge_base/${currentVulnTemplate}`;
  const agents = pathname === '/automation/agents';
  const cloudAgents = pathname === '/automation/cloud_agents';
  const agentExecutions = pathname === '/automation/agent_executions';
  const scheduler = pathname === '/automation/schedule';
  const mcp = pathname === '/mcp';

  if (showKB) return <KbTitle />;
  if (agents || cloudAgents || agentExecutions) return <Agents />;
  if (scheduler) return <Scheduler />;
  if (mcp) return <MCP />;
  return null;
};

export default Title;
